import React, { FC } from 'react';

export const ArrowTopIcon: FC<{ className?: string }> = ({className}) => {
	return <svg className={className} width="11" height="8" viewBox="0 0 11 8" fill="none"
				xmlns="http://www.w3.org/2000/svg">
		<path d="M1 6.19629L5.39264 1.80365L9.78527 6.19629" stroke="#14213D" strokeWidth="2" strokeLinecap="round"
			  strokeLinejoin="round"/>
	</svg>
}
